<emoji-mart [darkMode]="true"
            (emojiSelect)="select($event)"
            [showPreview]="false"
            [categoriesIcons]="{}"
            [emojiSize]="20"
            [showSingleCategory]="true"
            [style]="style"
            [isNative]="true"
></emoji-mart>
